// ------------------- Types.ts -------------------

export interface PriceChange {
  product_id: string;
  product_name: string;
  timestamp: string;
  local_id: number;
  old_price: number;
  new_price: number;
  user_id: string;
  user_name: string;
  price_type: 'restaurant' | 'delivery' | 'online' | 'desk' | 'all';
}

export interface PriceChangeStats {
  totalChanges: number;
  totalIncreases: number;
  totalDecreases: number;
  avgPriceChange: number;
  avgPercentageChange: number;
  mostChangedProduct: {
    product_name: string;
    count: number;
  } | null;
  topUserByChanges: {
    user_name: string;
    count: number;
  } | null;
  changesByType: {
    restaurant: number;
    delivery: number;
    online: number;
    desk: number;
    all: number;
  };
  changesByDay: Record<string, number>;
}

export type ViewMode = 'table' | 'stats';

export const PRICE_TYPE_LABELS: Record<string, string> = {
  restaurant: 'Restaurant',
  delivery: 'Delivery',
  online: 'Online',
  desk: 'Caja',
  all: 'Todos'
};
